import React, { useContext } from 'react'
import CommonBox from './components/CommonBox'
import GifImagesSection from './components/GifImagesSection'
import LoginContext from './context'

const Coupon = () => {
    const { isAuthenticated } = useContext(LoginContext)

    return (
        <>
            <section className='coupon-section'>
                <CommonBox heading=" 쿠폰함 " englishHeading=" coupon" isEnglishHeadingOnMobile={true} isAuthenticated={isAuthenticated}>
                </CommonBox>
            </section>
            <section className='gif-section flex lg:hidden items-center justify-center'>
                <GifImagesSection />
            </section>
        </>
    )
}

export default Coupon 